export type MailType =
  | MailTypeAnswerRequest
  | MailTypeStartNotification
  | MailTypeStartDecisionRequest;
type MailTypeAnswerRequest = 'answer_request';
type MailTypeStartNotification = 'start_notification';
type MailTypeStartDecisionRequest = 'start_decision_request';

const MailTypeKeyValues = {
  answer_request: '回答依頼',
  start_notification: '開始通知',
  start_decision_request: '開始判断依頼',
};
export const getMailTypeLabel = (mailType: MailType) => {
  return MailTypeKeyValues[mailType];
};
export const getOptions = () => {
  return Object.keys(MailTypeKeyValues).map((mailType: string) => {
    return {
      id: mailType,
      name: getMailTypeLabel(mailType as MailType),
    };
  });
};
